import bus, { EVENTS } from './bus';

export default class TaskTypeCrop extends PIXI.Graphics {
  constructor(crop, viewport, loader, skuList, params) {
    super();

    this.crop = crop;
    this.viewport = viewport;
    this.loader = loader;
    this.skuList = skuList;
    this.reference = params.reference;
    this.taskType = params.taskType;

    this.interactive = true;
    this.cursor = 'pointer';

    this.listenBusEvents();

    const { bottom_right, top_left } = this.crop.global_boundaries;
    const middlePoint = this.findCenterPointOfCrop(bottom_right, top_left);

    this.rect_y = parseFloat(middlePoint.y);
    this.rect_x = parseFloat(middlePoint.x);

    this.renderRect();
  }

  renderRect() {
    const {
      rect_x: x,
      rect_y: y
    } = this;

    const scale = this.viewport.scale.x;
    const selectedLegend = bus.selectedLegends.find(legend => legend.id === this.taskType);

    this.clear();
    this.removeChildren();

    const isCropInList = !!bus.updatedSkuList.find(item => (item.id.toString() === this.crop.class.id));

    if (selectedLegend && selectedLegend.isChecked && !bus.selectedMisplacedSkuId && isCropInList) {
      // draw triangle
      if (this.taskType === 'out_of_stock') {
        this.beginFill(0xff5050);
        this.lineStyle(this.getLineWidth(), 0xffffff);
        this.moveTo(x, y);
        this.lineTo(x + 10 / scale, y + 18 / scale);
        this.lineTo(x - 10 / scale, y + 18 / scale);
        this.closePath();
      }

      // draw circle
      if (this.taskType === 'missing') {
        this.lineStyle(this.getLineWidth(), 0xFFFFFF);
        this.beginFill(0xf9cb49);
        this.drawCircle(x, y, 9.5 / scale);
        this.endFill();
      }
    }
  }

  // actions
  mouseover() {
    if (this.timeout) clearTimeout(this.timeout);

    this.timeout = setTimeout(() => {
      this.showToolTip();
    }, 450);
  }

  touchstart() {
    if (this.timeout) clearTimeout(this.timeout);

    this.timeout = setTimeout(() => {
      this.showToolTip();
    }, 450);
  }

  touchend() {
    if (this.timeout) clearTimeout(this.timeout);
    this.destroyToolTip();
  }

  mouseout() {
    if (this.timeout) clearTimeout(this.timeout);
    this.destroyToolTip();
  }

  tap() {
    bus.$emit('CROP_TAPPED', this.crop);
  }

  // helpers
  getCropWithBounds() {
    return {
      bounds: this.getBounds(),
      crop: this.crop
    };
  }

  destroyToolTip = () => {
    if (!bus.selected_crop) {
      bus.$emit(EVENTS.DESTROY_TOOLTIP);
    }
  }

  showToolTip() {
    if (!bus.selected_crop) {
      bus.$emit(EVENTS.SHOW_TOOL_TIP, { crop: this.getCropWithBounds(), reference: this.reference });
    }
  }

  // helpers
  findCenterPointOfCrop = (bottom_right, top_left) => ({
    x: (bottom_right.x + top_left.x) / 2,
    y: (bottom_right.y + top_left.y) / 2
  })

  getLineWidth = () => {
    const lineWidth = 3 / this.viewport.scale.x;

    return lineWidth < 0.5 ? 0.5 : lineWidth;
  }

  listenBusEvents() {
    bus.$on(EVENTS.ZOOM_END, () => this.renderRect());
    bus.$on(EVENTS.RE_RENDER_CROP, () => this.renderRect());
    bus.$on(EVENTS.CHANGE_CROP_VISIBILITY, () => this.renderRect());
  }
}
